export const environment = {
    domain: 'customersso-stage.daikincomfort.com',
    clientId: 'ozrUdLXGMnnHfKtCoTeLlVaGrqEfD2Rk',
    scope: 'openid profile email',
    redirect_uri: window.location.origin + '/check-auth', 
    "ext-redirect_uri": window.location.origin + '/check-auth',
    audience: 'https://cusotmersso-stage.us.auth0.com/api/v2/',
    allowedList: '/api/*',
    apiUrl:'https://althermaxpress-test.daikincity.com/api/v1/',
    daikinCityQuickQuoteUrl: 'https://awstest.daikincity.com/v3/#/qQuote/',
    daikinCityProjectQuoteUrl: 'https://awstest.daikincity.com/v3/#/quote/quoteId/existingRecord',
    daikinCityBaseUrl: 'https://awstest.daikincity.com'
};